import { axios } from '../helpers/axios'

export async function getUserLanguage() {
  const { data } = await axios.get('/api/User/Language')

  return data
}
export async function getCodeVersion() {
  const { data } = await axios.get('/api/CodeVersion')

  return data
}
export async function globalAlert(key) {
  const { data } = await axios.get('/api/alert')

  return data
}
